import { $authHost } from '@/http'

const INTEGRATION_URL = '/order'

export const getIntegrationLotById = async (id) => {
  const { data } = await $authHost.get(`${INTEGRATION_URL}/${id}?expand=payment_term,products`)
  return data
}
